const configuredOrigin = String(process.env.REACT_APP_API_URL || '').trim();
const normalizedConfiguredOrigin = configuredOrigin && !/^https?:\/\//i.test(configuredOrigin)
  ? `https://${configuredOrigin}`
  : configuredOrigin;

export const API_ORIGIN = (normalizedConfiguredOrigin || 'http://localhost:3001').replace(/\/+$/, '');

export const apiUrl = (resource = '') => {
  const path = String(resource || '');
  if (!path) return API_ORIGIN;
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
};

export const assetUrl = (resource = '') => {
  if (!resource) return '';
  return apiUrl(resource);
};
